import { useMenuCopy, useNavCopy } from '@/context/site-chrome-copy'
import { IUser } from '@giphy/js-types'
import Link from 'next/link'
import { ILoggedInUser, IProfileUser } from 'types'
import ChannelAccessMenu from '../channel-access-menu'

export type Access = {
    channel: {
        avatar_url: string
        user_id: number
        display_name: string
        id: number
        slug: string
        url: string
    }
    create_datetime: string
    dashboard_url: string
    id: number
    last_login_datetime: string
    login_url: string
    permission_level: number
    update_datetime: string
}

export type AccessUser = {
    avatar: string
    avatar_url: string
    display_name: ''
    id: number
    is_verified: boolean
    profile_url: string
    username: string
    token: string
}

export type ChannelAccess = {
    access: Access[]
    emulated_user?: AccessUser | null
    user: AccessUser
}

export type AccessProps = {
    user: IUser & {
        is_staff?: boolean
        channel_access?: {
            access: Access[]
            emulated_user?: IUser
            user?: IUser
        }
    }
}

export const anchorClass =
    'min-w-20 flex-1 w-full whitespace-nowrap opacity-75 px-6 py-2 font-semibold text-white hover:opacity-100'

function ChannelsContent({ user }: { user: AccessProps['user'] }) {
    const copy = useMenuCopy()
    const nav = useNavCopy()
    const loggedInUser = user as import('types').ILoggedInUser | undefined
    const isStaff = user.is_staff === true
    const hasAccessDvr = loggedInUser && loggedInUser.permissions && loggedInUser.permissions.access_dvr === true
    const hasDashboardAnalytics = loggedInUser?.permissions?.dashboard_analytics === true
    const channelUrl = (user as IProfileUser).profile_url || `/${user.username}`
    const isUpgraded = (user as ILoggedInUser)?.is_upgraded === true
    const setOpenCollectionCabinet = () => {
        try {
            localStorage.setItem('openCollectionCabinet', 'true')
        } catch (_e) {}
    }

    return (
        <>
            <div className="flex h-full w-full flex-col items-start justify-center text-[15px] ">
                {hasDashboardAnalytics && (
                    <a href="/dashboard" className={anchorClass}>
                        {copy.dashboard}
                    </a>
                )}
                <Link href="/favorites" className={anchorClass} prefetch={false}>
                    {nav.favorites}
                </Link>
                {!isUpgraded && (
                    <a href="/apply" className={anchorClass}>
                        {copy.upgradeAccount}
                    </a>
                )}

                {channelUrl && (
                    <a
                        href={channelUrl}
                        className={anchorClass}
                        onClick={() => {
                            setOpenCollectionCabinet()
                        }}
                    >
                        {copy.collections}
                    </a>
                )}
                {(isStaff || hasAccessDvr) && (
                    <a href="/supercut" className={anchorClass}>
                        {copy.superCut}
                    </a>
                )}
                <div className="mx-6 my-3 h-0.5 w-[calc(100%-48px)] self-start border-[0.5px] bg-giphyWhite opacity-30" />
                <ChannelAccessMenu user={user as AccessProps['user']} />
                <Link href="/settings" className={anchorClass} prefetch={false}>
                    {copy.settings}
                </Link>
                <a href="/logout" className={anchorClass}>
                    {copy.logOut}
                </a>
            </div>
        </>
    )
}

export default ChannelsContent
